import { render } from "./CustomerSignUp.html?vue&type=template&id=356a19ce&scoped=true&external"
import script from "./CustomerSignUp.js?vue&type=script&lang=js&external"
export * from "./CustomerSignUp.js?vue&type=script&lang=js&external"

import "./CustomerSignUp.css?vue&type=style&index=0&id=356a19ce&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356a19ce"]])

export default __exports__